import { ReactElement } from 'react';
import { BrandedStoreSlice } from '@adapters/prismic/types/brandedStorePage';
import BrandedStoreSliceHandler from '../BrandedStoreSliceHandler';
import { PageType } from '@adapters/prismic/types/slices';
import { AlgonomyPlacement } from '@components/global/Recommendations/Loader';
import styles from './BrandedStoreSliceZone.module.scss';

export interface BrandedStoreSliceZoneProps {
  slices?: BrandedStoreSlice[];
  brandRecommendations?: AlgonomyPlacement[];
  isEnhancedPlp?: boolean;
  brandedStoreCoopAttribute?: string | null;
}

const BrandedStoreSliceZone = ({
  slices,
  brandRecommendations,
  isEnhancedPlp,
  brandedStoreCoopAttribute,
}: BrandedStoreSliceZoneProps): ReactElement => (
  <div>
    {slices?.map((slice: BrandedStoreSlice, i: number) => (
      <section
        key={`branded-store-slice-${slice?.id}`}
        className={isEnhancedPlp ? styles.slice : ''}
      >
        <BrandedStoreSliceHandler
          slice={slice}
          pageType={PageType.brandedStorePage}
          sliceIndex={i}
          recommendations={brandRecommendations}
          brandedStoreCoopAttribute={brandedStoreCoopAttribute}
        />
      </section>
    ))}
  </div>
);

export default BrandedStoreSliceZone;
